export const ACTION_TITLE_LENGTH_MAX = 100;

export const ISSUE_TITLE_LENGTH_MAX = 100;

export const ISSUE_DESCRIPTION_LENGTH_MAX = 1000;

export const ISSUE_IMPACT_LENGTH_MAX = 10000;

export const ACTION_DESCRIPTION_LENGTH_MAX = 1000;

export const ISSUE_COMMENT_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MIN = 1;

export const DISCARD_MESSAGE_LENGTH_MAX = 1000;

export const SLA_DESCRIPTION_LENGTH_MAX = 100;

export const SUBTYPE_NAME_LENGTH_MAX = 100;
export const ROOT_CAUSE_LENGTH_MAX = 10000;
export const RECOMMENDATIONS_LENGTH_MAX = 10000;
export const MANAGEMENT_RESPONSE_LENGTH_MAX = 10000;
export const REMEDIATION_LENGTH_MAX = 10000;

export const ISSUE_SUBTYPE_NONE_VALUE = '_none_';
